import React, { useState } from "react";
import {
  CancelButton,
  SubmitButton,
} from "../../../../../../Components/Utils/Buttons";
import { useFormik } from "formik";
import {
  FormikSelectTwoSmall,
} from "../../../../../../Components/Utils/Select";
import { NuDateSmall } from "../../../../../../Components/Utils/Input";
import NewReportTable from "../../../../../../Components/Others/NewReportTable";
import UseFetchReportData from "../../../../../../Components/Hooks/useFetchReportData";
import useFetchMataData from "../../../../../../Components/Hooks/useFetchMataData";
import {
  DownloadPDF,
  DownloadXLXS,
} from "../../../../../../Components/Utils/Download";
import UseCustomerDropDownNew from "../../../../../../Components/Hooks/useCustomerSearch";

function ClientTicketsReport() {
  const [showFilter, setShowFilter] = useState(false);
  // const { data: RFQAssignee } = UseDropDown("/user/procurement/drop-down");
  const [filter, setFilter] = useState(false);

  const headers = [
    {
      title: "Ref.",
      width: "10%",
      field: "Ref",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Date",
      width: "10%",
      field: "Date",
      textAlign: "left",
      rowAlign: "left",
      type: "date",
    },
    {
      title: "Client",
      width: "10%",
      field: "Client",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Subject",
      width: "10%",
      field: "Subject",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Priority",
      width: "10%",
      field: "Priority",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Status",
      width: "10%",
      field: "Status",
      textAlign: "left",
      rowAlign: "left",
    },
  ];

  const [filterProps, setFilterProps] = useState({
      status:"",
      dateFrom:"",
      dateTo:"",
      priority:""
  });

  const [params, setParams] = useState({
      status:"",
      dateFrom:"",
      dateTo:"",
      priority:""
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: filterProps,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (value) => {
      setParams({
            status:value.status||"",
            dateFrom:value.dateFrom||"",
            dateTo:value.dateTo||"",
            priority:value.priority||""
      });
      setTimeout(() => {
        setFilter(true);
        // closeFilterDialog();
      }, 1000);
    },
  });
  const { data, getData, dataLoading, total, other } = UseFetchReportData(
    "/xlsx-report/filter-client-tickets",
    params
  );

  function closeFilterDialog() {
    setShowFilter(false);
    formik.resetForm();
    setFilter(false);
    setParams({
      status:"",
      dateFrom:"",
      dateTo:"",
      priority:""
    });
  }

  const [searchClient, setSearchClient] = useState("");

  const { data: client, setDataCustomer } = UseCustomerDropDownNew(
    "/clients/drop-down",
    searchClient
  );
  const { value: Priority, getData: refPriority } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "priority"
  );

  const { value: Status, getData: refStatus } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Status_Support_Tickets"
  );
  return (
    <>
      <div className="w-full h-full overflow-y-auto">
        <div className="flex gap-x-2 justify-between  w-full  py-2">
          <div className=" max-w-[300px] pr-7 ">
            <p className=" font-semibold text-xs 2xl:text-sm  ">
              Client Tickets Report : {data?.length}
            </p>
          </div>
          <div className=" flex-1 ">
            <form onSubmit={formik.handleSubmit}>
              <div className=" w-full grid grid-cols-5  gap-3">
                <NuDateSmall
                  label="From "
                  placeholder="dd/mm/yyyy"
                  formik={formik}
                  name="dateFrom"
                  width="w-full"
                />
                <NuDateSmall
                  label="To "
                  placeholder="dd/mm/yyyy"
                  formik={formik}
                  name="dateTo"
                  width="w-full"
                />

                <FormikSelectTwoSmall
                  label="Priority"
                  Options={Priority}
                  formik={formik}
                  placeholder="Choose"
                  name="priority"
                  width="w-full"
                  displayProperty={"Priority"}
                  propertyName={"priority"}
                  getFunc={refPriority}
                />

                <FormikSelectTwoSmall
                  label="Status"
                  Options={Status}
                  formik={formik}
                  placeholder="Choose"
                  name="status"
                  width="w-full "
                />
                <div className=" w-full flex justify-end ">
                  <div className=" w-full flex items-end gap-2">
                    <SubmitButton name="Apply" />
                    <CancelButton
                      label="Clear"
                      handleClick={closeFilterDialog}
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div className=" w-[80px] flex justify-end items-end gap-4 ">
            <DownloadPDF
              url={`/xlsx-report/export-client-tickets-pdf`}
              fileName="Survey Report"
              params={params}
            />
            <DownloadXLXS
              url={`/xlsx-report/export-client-tickets-excel`}
              fileName="Survey Report"
              params={params}
            />
          </div>
        </div>
               <NewReportTable
          headers={headers}
          data={data}
          dataLoading={dataLoading}
        />
      </div>
    </>
  );
}

export default ClientTicketsReport;
